import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface AccordionItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function AccordionItem({
  question,
  answer,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border-b border-gray-200 last:border-0" data-id="element-297">
      <button className="w-full py-4 px-6 flex items-center justify-between text-left focus:outline-none bg-white hover:bg-gray-50 transition-colors" onClick={onClick} aria-expanded={isOpen} data-id="element-298">
        <span className="font-bold text-emerald-800 text-lg pr-4" data-id="element-299">
          {question}
        </span>
        {isOpen ? <ChevronUp className="h-5 w-5 text-emerald-600 flex-shrink-0" data-id="element-300" /> : <ChevronDown className="h-5 w-5 text-emerald-600 flex-shrink-0" data-id="element-301" />}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-302">
        <div className="p-6 pt-0 text-gray-700 bg-white" data-id="element-303">{answer}</div>
      </div>
    </div>;
}
interface AccordionProps {
  items: {
    question: string;
    answer: string;
  }[];
}
export function Accordion({
  items
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const handleClick = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="w-full max-w-3xl mx-auto bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-304">
      {items.map((item, index) => <AccordionItem key={index} question={item.question} answer={item.answer} isOpen={openIndex === index} onClick={() => handleClick(index)} data-id="element-305" />)}
    </div>;
}